import React from "react";
import { faPlusCircle, faTimesCircle } from "@fortawesome/pro-solid-svg-icons";
import { useRouter } from "next/navigation";

import Button from "@/components/button";
import { AnimationType, PixelMode } from "@/gql/generated/graphql";
import { useModal } from "@/hooks/use-modal";
import * as editorActions from "@/lib/state/actions/editor-actions";
import { useAppDispatch } from "@/lib/state/store";

import { ButtonBar, Module } from "../../layouts";
import { ButtonGroup } from "../../layouts/button-group";

import ModalTitle from "./modal-title";

export default function ConfirmCreateAvatarModal() {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const { closeModal } = useModal();

  const onCreateClicked = async () => {
    router.push("/editor?newAvatar=true");
    closeModal();
  };

  const onCancelClicked = () => {
    closeModal();
  };

  return (
    <div>
      <ModalTitle>Create Profile Picture</ModalTitle>
      <Module>
        <p>This will create a new animation in the editor.</p>
        <p>Any unsaved work will be lost. Do you want to continue?</p>
      </Module>
      <ButtonBar>
        <ButtonGroup align="right">
          <Button
            icon={faPlusCircle}
            onClick={onCreateClicked}
            type="positive"
          >
            Create Profile Picture
          </Button>
          <Button
            icon={faTimesCircle}
            onClick={onCancelClicked}
            type="negative"
          >
            Cancel
          </Button>
        </ButtonGroup>
      </ButtonBar>
    </div>
  );
}
